{
  "common": {
    "twoFactorAuthentication": "Two-factor authentication",
    "backToSignIn": "Back to Sign in",
    "authyIcon": "AuthyIcon"
  },
  "loginPage": {
    "subtitle": "Sign in",
    "headerText": "Enter your email and password below to sign in to your account",
    "username": "Username",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "password": "Password",
    "forgotPassword": "Forgot password?"
  },
  "mfaOptionsPage": {
    "headerText": "Please select the method you would like to use",
    "authy": "Authy",
    "authyDescription": "Download the authy app for fast, secure, offline authentication",
    "mostSecure": "Most Secure",
    "sms": "SMS",
    "smsDescription": "Receive an SMS to your device. Available network required",
    "call": "Call",
    "callDescription": "Receive a call to your device. Available network required"
  },
  "verificationPage": {
    "headerText": "Please enter the code provided from your chosen verification method",
    "verificationCode": "Verification Code",
    "verificationCodePlaceholder": "Enter 6 digit code",
    "linkText": "Haven't received your code?",
    "pushText": "Haven’t received the push notification?",
    "buttonText": "Verify and sign in"
  },
  "authyModal": {
    "header": "Authy Setup",
    "stepOne": "Step 1: Download Authy",
    "stepOneDescription": "Please download the Authy app to your mobile device. It is available on Android and iOS.",
    "stepTwo": "Step 2: Register Device",
    "stepTwoDescription": "Please register with the same phone number you have registered with at Alpha",
    "stepThree": "Step 3: Use app to authenticate",
    "stepThreeDescription": "You will then see Alpha automatically appear within the Authy app.",
    "stepThreeDescriptionLineTwo": "You can now use this token to securely login to your account and authenticate actions within the platform.",
    "checkboxText": "Do not show me this message again"
  },
  "error": {
    "mfaError": "There was an error sending secure token, please try again.",
    "verificationError": "Verification code is incorrect.",
    "signInError": "Incorrect username or password.",
    "sessionTimeout": "Session timed out for this user",
    "newPasswordError": "Incorrect new password format",
    "passwordHistoryError": "This password has been used before. Please choose a different one",
    "resetPasswordError": "There was an error resetting your password.",
    "usernameError": "There was an error with the username provided, please try again.",
    "invalidCode": "There was an error confirming your token",
    "passwordPolicyLoadError": "Unable to load password requirements. Please refresh and try again."
  },
  "signUpPage": {
    "subtitle": "Verify your email",
    "step": "Step 1",
    "headerText": "To get started, please enter your username and the temporary password below. You can find your temporary password in your welcome email we sent to you.",
    "username": "Username",
    "usernamePlaceholder": "Enter your username",
    "passwordPlaceholder": "Enter your temporary password",
    "password": "Temporary Password"
  },
  "updatePasswordPage": {
    "subtitle": "Set your new password",
    "step": "Step 2",
    "headerText": "Thank you for verifying your email. You can now set your new password in line with the criteria below.",
    "passwordPlaceholder": "Enter your new password",
    "password": "New Password"
  },
  "onboardingMfaOptionsPage": {
    "subtitle": "Set up Two-factor Authentication",
    "step": "Step 3",
    "headerText": "Two-factor authentication must be enabled with your registered device in order to use the platform. Please select your preferred method."
  },
  "onboardingVerificationPage": {
    "subtitle": "Verify mobile device",
    "step": "Step 4",
    "headerText": "Finally, please use your selected authentication method to verify your mobile device.",
    "verificationCode": "Verification Code",
    "verificationCodePlaceholder": "Enter 6 digit code",
    "linkText": "Haven't received your code?"
  },
  "progress": {
    "onboarding": {
      "step1": "Welcome email verification",
      "step2": "New password",
      "step3": "Security",
      "step4": "Verify mobile device"
    }
  },
  "resetPasswordRequestPage": {
    "header": "Password Reset",
    "headerText": "To reset your password please enter your username below. We will send out instructions to resetting your password.",
    "username": "Username",
    "usernamePlaceholder": "Enter your username",
    "buttonText": "Send Code"
  },
  "resetPasswordPage": {
    "header": "Password Reset",
    "verificationText": "A verification code has been emailed to",
    "headerText": "Please input the code along with your new password below to continue.",
    "verificationCode": "Verification Code",
    "verificationCodePlaceholder": "Enter your code",
    "newPassword": "New Password",
    "newPasswordPlaceholder": "Enter your new password",
    "buttonText": "Reset Password",
    "resetPasswordSuccess": "Your password has been successfully reset.",
    "verificationCodeSuccess": "Verification code sent to: "
  },
  "validationLabels": {
    "min12Characters": "12 characters minimum",
    "min1LowerCase": "One lowercase character",
    "min1UpperCase": "One uppercase character",
    "min1Number": "One number",
    "min1SpecialCharacter": "One special character"
  },
  "welcomePage": {
    "logIn": "Welcome back, <userName/>",
    "signUp": "Welcome, <userName/>",
    "loggingMessage": "Logging you in now..."
  },
  "redirect-to-login-message": "It looks like you already have an account. Please log in again with your existing details.",
  "redirect-to-sign-up-flow": "Setup needed, please enter your details again to setup your account.",
  "push": {
    "title": "A push notification has been sent to your device.",
    "subtitle": "Approve the push notification on your device to continue."
  },
  "userAccountsNotSetup": {
    "title": "You have no entities to manage",
    "body": "Please contact your Entity manager for help."
  }
}
